/**
 * Notification-center read state.
 *
 * Implementation moved to `useReadState`, which mirrors the marker into an
 * encrypted `kind-30078` event so it syncs across the user's devices while
 * keeping the same instant localStorage fast-path and the same public API
 * (`{ lastRead, seenAt, markAllRead }`). Re-exported here so existing imports
 * keep working unchanged.
 */
export { useNotificationsRead } from '@/hooks/useReadState';
